<template>
  <div
    class="column has-text-centered opportunity-item"
    :style="{ color: sponsorshipIsActive ? 'black' : '#d1d1d1' }"
  >
    <b-icon
      icon="money-bill-alt"
      :style="{ color: sponsorshipIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span>Patrocínio</span>
  </div>
</template>

<script>
export default {
  props: ["sponsorshipIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
